import { Validators } from '@angular/forms';
import { TypedFormGroup, TypedFormControl } from '@principle-theorem/ng-shared';
import {
  IAccToothInjury,
  AccToothNumber,
  AccToothInjuryClassification,
  AccToothPreAccidentCondition,
} from '@principle-theorem/principle-core/interfaces';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { setRequiredValidation, hasRequiredError } from './form-group-helpers';
import { isNumber } from 'lodash';

export class AccToothInjuryFormGroup extends TypedFormGroup<IAccToothInjury> {
  private readonly destroy$ = new Subject<void>();

  constructor(data?: Partial<IAccToothInjury>) {
    super({
      toothNumber: new TypedFormControl<AccToothNumber>(
        undefined,
        Validators.required
      ),
      injuryClassification: new TypedFormControl<
        AccToothInjuryClassification[]
      >(undefined, Validators.required),
      preAccidentCondition: new TypedFormControl<
        AccToothPreAccidentCondition[]
      >(undefined, Validators.required),
    });

    if (data) {
      this.patchValue(data);
    }

    // injuryClassification is required when toothNumber has a value
    this.controls.toothNumber.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) =>
        setRequiredValidation(
          isNumber(value),
          this.controls.injuryClassification
        )
      );
  }

  destroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get injuryClassificationRequiredError(): boolean {
    return hasRequiredError(this.controls.injuryClassification);
  }

  get preAccidentConditionRequiredError(): boolean {
    return hasRequiredError(this.controls.preAccidentCondition);
  }
}
